<div
  (click)="expand.emit()"
  (keydown.enter)="expand.emit()"
  (keydown.space)="expand.emit(); $event.preventDefault()"
  tabindex="0"
  role="button"
  class="flex items-center gap-[4px] cursor-pointer"
>
  <svg
    width="20"
    height="20"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.65625 1.16071V0.870536C7.65625 0.40625 7.27344 0 6.83594 0H4.10156C3.66406 0 3.28125 0.40625 3.28125 0.870536V1.16071H0V3.48214H3.28125V3.77232C3.28125 4.23661 3.66406 4.64286 4.10156 4.64286H6.83594C7.27344 4.64286 7.65625 4.23661 7.65625 3.77232V3.48214H17.5V1.16071H7.65625ZM4.375 3.48214V1.16071H6.5625V3.48214H4.375ZM14.2187 6.67411C14.2187 6.20982 13.8359 5.80357 13.3984 5.80357H10.6641C10.2266 5.80357 9.84375 6.20982 9.84375 6.67411V6.96429H0V9.28571H9.84375V9.57589C9.84375 10.0402 10.2266 10.4464 10.6641 10.4464H13.3984C13.8359 10.4464 14.2187 10.0402 14.2187 9.57589V9.28571H17.5V6.96429H14.2187V6.67411ZM10.9375 9.28571V6.96429H13.125V9.28571H10.9375ZM7.65625 12.4777C7.65625 12.0134 7.27344 11.6071 6.83594 11.6071H4.10156C3.66406 11.6071 3.28125 12.0134 3.28125 12.4777V12.7679H0V15.0893H3.28125V15.3795C3.28125 15.8438 3.66406 16.25 4.10156 16.25H6.83594C7.27344 16.25 7.65625 15.8438 7.65625 15.3795V15.0893H17.5V12.7679H7.65625V12.4777ZM4.375 15.0893V12.7679H6.5625V15.0893H4.375Z"
      fill="#0066CC"
    />
  </svg>
  <div class="text-label-xs-semibold text-link">
    {{ label }}
  </div>
  <svg
    width="10"
    height="10"
    viewBox="0 0 9 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.375 5L0 0H8.75L4.375 5Z"
      fill="#0066CC"
    />
  </svg>
</div>
